import React, { useState, useRef, useEffect } from 'react';
import { getHostUrl } from '../../utils/hostConfig';
import { Icon } from '../Icons';

/**
 * 네비게이션 드롭다운 컴포넌트
 * 부모 li 기준 absolute 배치 — Portal 불필요, 위치 계산 불필요
 */
const NavDropdown = ({ label, items, host, isActive, t }) => {
  const [isOpen, setIsOpen] = useState(false);
  const timeoutRef = useRef(null);

  const handleMouseEnter = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    setIsOpen(true);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => setIsOpen(false), 120);
  };

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  return (
    <li
      className="relative"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <a
        href={getHostUrl(host, '/')}
        className={`flex items-center no-underline text-xs font-normal px-3 h-11 leading-[44px] bg-transparent border-none cursor-pointer whitespace-nowrap hover:text-blue-500 transition-colors ${
          isActive ? 'text-blue-500' : 'text-gray-900'
        }`}
      >
        {label}
      </a>

      {/* 드롭다운 — 부모 li 기준 absolute, CSS transition */}
      <div
        className="absolute left-1/2 pt-1"
        style={{
          transform: `translateX(-50%) translateY(${isOpen ? '0' : '-4px'})`,
          opacity: isOpen ? 1 : 0,
          pointerEvents: isOpen ? 'auto' : 'none',
          transition: 'opacity 0.18s ease, transform 0.18s ease',
          zIndex: 99999,
        }}
      >
        <div className="bg-white border border-gray-200 rounded-xl shadow-lg p-2 min-w-[200px] flex flex-row gap-1">
          {items.map((item) => (
            <a
              key={item.path}
              href={getHostUrl(host, item.path)}
              className="flex flex-col items-center justify-center gap-1.5 px-4 py-3 rounded-lg hover:bg-gray-50 text-gray-700 no-underline text-xs font-medium min-w-[70px] text-center whitespace-nowrap transition-colors"
              {...(item.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
            >
              <span className="flex items-center justify-center w-7 h-7 text-xl">
                <Icon name={item.icon} size={20} />
              </span>
              <span>{t(item.labelKey) || item.label}</span>
            </a>
          ))}
        </div>
      </div>
    </li>
  );
};

export default NavDropdown;
